import React from "react";
import { Avatar, Flex, Typography } from "antd";
import { HiPhoneMissedCall } from "react-icons/hi";
import AudioPlayer from "../../common/AudioPlayer";
import "./index.scss";

const MissedCallIcon = HiPhoneMissedCall as unknown as React.FC;

const { Text } = Typography;

interface CallVoiceBubbleProps {
  msg: any;
}

const CallVoiceBubble: React.FC<CallVoiceBubbleProps> = ({ msg }) => {
  return (
    <Flex
      justify={msg.isUser ? "end" : "start"}
      gap={10}
      className="call-voice-bubble"
    >
      {msg.isUser ? (
        <div className="bubble-content bubble-user">
          {msg.filePath ? (
            <>
              <Text>You sent a voicemail</Text>
              <AudioPlayer audioUrl={msg.filePath} messageId={String(msg.id)} />
            </>
          ) : (
            <>Voicecall</>
          )}
        </div>
      ) : (
        <>
          <Avatar className="other-sender-avatar" size="large">
            {msg.sender ? msg.sender[0] : "+"}
          </Avatar>
          <div className="bubble-content bubble-other">
            {msg.filePath ? (
              <div className="voice-mail">
                <Text>You received a voicemail</Text>
                <AudioPlayer audioUrl={msg.filePath} messageId={String(msg.id)} />
              </div>
            ) : (
              <div className="missed-call">
                <MissedCallIcon />
                <Text>{msg.message}</Text>
              </div>
            )}
          </div>
        </>
      )}
    </Flex>
  );
};

export default CallVoiceBubble;
